import { api } from '@/lib/api-manager'
import type { DesiredEducationCourse } from '@/types/education/desired-education-course'
import type { DisciplineAnalysisResult } from '@/types/education/discipline-analysis-result'
import type { PreviousEducationCourse } from '@/types/education/previous-education-course'

export async function DisciplineAnalysisService(
  desiredCourses?: DesiredEducationCourse[],
  previousCourses?: PreviousEducationCourse[]
): Promise<DisciplineAnalysisResult[]> {
  const desiredDisciplines = desiredCourses?.map(
    (discipline) => discipline.name
  )
  const previousDisciplines = previousCourses?.map(
    (discipline) => discipline.name
  )

  return (
    await api.post('v1/educations/analysis/equivalence-analysis', {
      desiredDisciplines,
      previousDisciplines
    })
  ).data.data
}
